import { useQuery } from '@apollo/client';

import { GET_TOURNAMENT_POLICIES } from 'config/graphql/queries';
import { isStandalone } from 'utils/environment';

const useTournamentPolicies = (tournamentId: string) => {
  const { data } = useQuery(GET_TOURNAMENT_POLICIES, {
    fetchPolicy: isStandalone() ? 'cache-only' : 'cache-first',
    variables: { clubSparkTournamentId: tournamentId },
  });
  return data?.tournamentPolicies;
};

export default useTournamentPolicies;
